export const missedCallRateColumns = [
    {
        title: "Hotel Name",
        dataIndex: "hotel_name",
        key: "hotel_name",
        sorter: () => {},
    },
    {
        title: "PBX Missed Call Count",
        dataIndex: "pbx_missed_calls",
        key: "pbx_missed_calls",
        sorter: () => {},
    },
    {
        title: "Kiosk Missed Call Count",
        dataIndex: "kiosk_missed_calls",
        key: "kiosk_missed_calls",
        sorter: () => {},
    },
    {
        title: "Total PBX Calls",
        dataIndex: "pbx_missed_calls_total",
        key: "pbx_missed_calls_total",
        sorter: () => {},
    },
    {
        title: "Total Kiosk Calls",
        dataIndex: "kiosk_missed_calls_total",
        key: "kiosk_missed_calls_total",
        sorter: () => {},
    },
    {
        title: "Total  Calls",
        dataIndex: "calls_total",
        key: "calls_total",
        sorter: () => {},
    },
    {
        title: "Missed Call Rate",
        dataIndex: "missed_call_rate",
        key: "missed_call_rate",
        sorter: () => {},
    },
];